(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvChangeTemplateFormat', drvChangeTemplateFormat);

    drvChangeTemplateFormat.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvChangeTemplateFormat
     *
     * @description
     * A select input for choosing the template format for a document template
     *
     * # Scope Properties
     *
     * {DocumentTemplate} documentTemplate
     */
    function drvChangeTemplateFormat() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/DocumentTemplate/change-template-format.tmpl.html',
            controller: ChangeTemplateFormatCtrl,
            controllerAs: 'drvCtrl',
            scope: {},
            bindToController: {
                documentTemplate: '<'
            }
        };
        return directive;
    }

    ChangeTemplateFormatCtrl.$inject = ['$scope', 'DocumentTemplate'];

    function ChangeTemplateFormatCtrl($scope, DocumentTemplate) {
        var drvCtrl = this;
        drvCtrl.disableSelect = disableSelect;
        drvCtrl.templateFormats = [];

        activate();

        function activate() {
            $scope.$watch('drvCtrl.documentTemplate.usageTypeDetails.OutputFormats', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    updateTemplateFormats();
                }
            });

            updateTemplateFormats();
        }

        /**
         * The document template format control should be disabled if there is only one option.
         *
         * @returns {bool} stating if the select control should be disabled
         */
        function disableSelect() {
            var count = 0;

            if (!_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats) &&
                (drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Pdf') ||
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Doc') ||
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Docx'))) {
                count++;
            }

            if (!_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats) &&
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Txt')) {
                count++;
            }

            if (!_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats) &&
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Html')) {
                count++;
            }

            return count < 2;
        }

        /**
         * Should the template format select option be shown for the current usage type.
         *
         * @param {string} option - The template format option reference
         *
         * @returns {bool} stating if the option should be shown.
         */
        function showOption(option) {
            var result = false;

            if (option === 'fileUpload' && !_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats) &&
                (drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Pdf') ||
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Doc') ||
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Docx'))) {
                    result = true;
            }

            if (option === 'plainText' && !_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats) &&
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Txt')) {
                    result = true;
            }

            if (option === 'richText' && !_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats) &&
                drvCtrl.documentTemplate.usageTypeDetails.OutputFormats.includes('Html')) {
                    result = true;
            }

            return result;
        }

        function updateTemplateFormats() {
            if (!_.isNil(drvCtrl.documentTemplate) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails) && !_.isNil(drvCtrl.documentTemplate.usageTypeDetails.OutputFormats)) {
                var templateFormats = [];

                if (showOption('fileUpload')) {
                    templateFormats.push({ Reference: 'fileUpload', Name: 'File Upload' });
                }
                if (showOption('plainText')) {
                    templateFormats.push({ Reference: 'plainText', Name: 'Plain Text' });
                }
                if (showOption('richText')) {
                    templateFormats.push({ Reference: 'richText', Name: 'Html' });
                }

                drvCtrl.templateFormats = templateFormats;
            } else {
                drvCtrl.templateFormats = [];
            }
        }
    }
})();